var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Colors } from "@brg/ui";
export var hintToolbarStylesWhite = {
    fontFamily: 'Inter',
    fontWeight: 400,
    padding: '2px 8px 4px 8px',
    fontSize: '11px',
    lineHeight: '13px',
    letterSpacing: '-0.02em',
    color: Colors.galBlack61,
    backgroundColor: Colors.galBlack10,
    background: Colors.galBlack10
};
export var hintToolbarStylesDark = {
    fontFamily: 'Inter',
    fontWeight: 400,
    padding: '2px 8px 4px 8px',
    fontSize: '11px',
    lineHeight: '13px',
    letterSpacing: '-0.02em',
    color: '#fff',
    backgroundColor: '#353A3E',
    background: '#353A3E'
};
export var tooptipStylesWhite = __assign(__assign({}, hintToolbarStylesWhite), { textColor: hintToolbarStylesWhite.color, id: 'tooltip-parent-element', className: 'tooltip-parent-element' });
export var tooptipStylesDark = __assign(__assign({}, hintToolbarStylesDark), { textColor: '#fff', id: 'tooltip-parent-element', className: 'tooltip-parent-element' });
export var navbarCreateTooltipProps = {
    id: 'tooltip-navbar-create',
    className: 'tooltip-navbar-create',
};
export var getTooltipStyles = function (theme) {
    var _a;
    var isDark = ["#000000", Colors.geo].includes((_a = theme === null || theme === void 0 ? void 0 : theme.app) === null || _a === void 0 ? void 0 : _a.backgroundColor);
    return isDark ? tooptipStylesDark : tooptipStylesWhite;
};
//# sourceMappingURL=tooltipStyles.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Colors } from "@brg/ui";
export var hintToolbarStylesWhite = {
    fontFamily: 'Inter',
    fontWeight: 400,
    padding: '2px 8px 4px 8px',
    fontSize: '11px',
    lineHeight: '13px',
    letterSpacing: '-0.02em',
    color: Colors.galBlack61,
    backgroundColor: Colors.galBlack10,
    background: Colors.galBlack10
};
export var hintToolbarStylesDark = {
    fontFamily: 'Inter',
    fontWeight: 400,
    padding: '2px 8px 4px 8px',
    fontSize: '11px',
    lineHeight: '13px',
    letterSpacing: '-0.02em',
    color: '#fff',
    backgroundColor: '#353A3E',
    background: '#353A3E'
};
export var tooptipStylesWhite = __assign(__assign({}, hintToolbarStylesWhite), { textColor: hintToolbarStylesWhite.color, id: 'tooltip-parent-element', className: 'tooltip-parent-element' });
export var tooptipStylesDark = __assign(__assign({}, hintToolbarStylesDark), { textColor: '#fff', id: 'tooltip-parent-element', className: 'tooltip-parent-element' });
export var navbarCreateTooltipProps = {
    id: 'tooltip-navbar-create',
    className: 'tooltip-navbar-create',
};
export var getTooltipStyles = function (theme) {
    var _a;
    var isDark = ["#000000", Colors.geo].includes((_a = theme === null || theme === void 0 ? void 0 : theme.app) === null || _a === void 0 ? void 0 : _a.backgroundColor);
    return isDark ? tooptipStylesDark : tooptipStylesWhite;
};
//# sourceMappingURL=tooltipStyles.js.map